import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';

import Input from 'src/components/Form/elements/Input';
import ArrowButton from 'components/ArrowButton';
import LawFirmSelector from './LawFirmSelector';

import vw from 'src/styles/utils';
import media from 'src/styles/media';

import data from 'src/data/legal-tab5';
// import data from 'src/data/legal-test';

// BEFORE GOING TO PRODUCTION:
// TODO: change the data source from legal-test to legal
// TODO: UPDATE MAKE HOOKS OF LEGAL.JS AND LAWFIRMSELECTOR.JS TO PRODUCTION
// TODO: UPDATE NETLIFY THANK-YOU/ERROR REDIRECT URLS WITH THE PRODUCTION ONES ON LEGAL.JS
// TODO: ADD PRODUCTION DOMAIN TO RECAPTCHA ADMIN

function Legal(props) {
  const { setLegalContactOpen } = props;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [lawFirmID, setLawFirmID] = useState(null);
  const [dropdownHidden, setDropdownHidden] = useState(true);
  const [strataLot, setStrataLot] = useState('');
  const [unitNumber, setUnitNumber] = useState('');
  const [purchaserEmail, setPurchaserEmail] = useState('');
  const [isRootVisible, setIsRootVisible] = useState(true); // new state for root visibility

  const rootRef = useRef(); // creating a reference to the root

  // effect to add and cleanup event listener for clicks
  useEffect(() => {
    function handleClickOutside(event) {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setIsRootVisible(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [rootRef]);

  const $form = useRef();

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // send strata lot data to the test hook
    // test hook https://hook.us1.make.com/cu0911j1udboap4vhyygpkz8r69go005
    // production hook https://hook.us1.make.com/o646ybdbmmp3lp7m1tayc8raf2ljhuwv
    // if the response is status: "success", then submit the form
    // if the response is status: "fail", then alert the user
    try {
      const response = await fetch(
        // `https://hook.us1.make.com/gwym16ls1nqm7wecxxd1minano6u55b7?strata_lot=${strataLot}`
        `https://io.bamdigital.com/webhook/008fb01e-ce80-43cc-9433-b1b2e6ad5cae?strata_lot=${strataLot}`
      );
      const data = await response.json();

      // send strata lot data to the web hook for Inventory
      // production hook https://hook.us1.make.com/r1rq6r63uocrmlcndpok74p0n86nh46e
      // if the response is status: "success", then submit the form
      // if the response is status: "fail", then alert the user
      const responseInventory = await fetch(
        `https://hook.us1.make.com/3ikoq6q1hodk2a7wofz4nt3gfx64lq36?strata_lot=${strataLot}&unit_number=${unitNumber}&purchaser_email=${purchaserEmail}`
      );
      const dataInventory = await responseInventory.json();

      if (data.status === 'error') {
        // Checking strat lot if it's already exist in Questions
        // Scenario: Shape - Richmond Center / Legal Form - Richmond Centre 1 (Strata Lot Eval)
        console.error('Strata lot already exists.');
        console.log('Redirecting...');
        setIsSubmitting(false);
        setLegalContactOpen(true);
      } else if (dataInventory.status === 'error') {
        // Checking strat lot if it's valid from Inventory list
        // Scenario: Shape - Richmond Center / Legal Form - Richmond Centre 1 (Inventory)
        console.error("Strata lot can't be found.");

        alert(
          'The Unit and Strata Lot do not match the Purchaser email we have on file. Please try again or contact info@theamazingbrentwood.com for assistance.'
        );
        console.log('Redirecting...');
        setIsSubmitting(false);
      } else {
        console.log('Strata Lot verified, now submitting the form.');

        // AFTER THIS DOESN'T SEEM TO WORK
        var form = $form.current;
        var missing = '';
        var required = { contact_email: 'Email' };
        var customRequired = document.querySelectorAll(
          'input:required, textarea:required, select:required, checkbox:required'
        );

        var FirstName = document.getElementById('contact[first_name]').value;
        var LegalFirstName = document.getElementById(
          'contact[l_first_name]'
        ).value;
        var regexLetter =
          /^[\u4E00-\u9FFF\u3400-\u4DFF\uF900-\uFAFFa-zA-Z /.-]*$/;

        if (!regexLetter.test(FirstName)) {
          missing += '- First name is invalid\r\n';
        }
        if (!regexLetter.test(LegalFirstName)) {
          missing += '- Legal representative first name is invalid\r\n';
        }
        var LastName = document.getElementById('contact[last_name]').value;
        if (!regexLetter.test(LastName)) {
          missing += '- Last name is invalid\r\n';
        }

        var LegalLastName = document.getElementById(
          'contact[l_last_name]'
        ).value;
        if (!regexLetter.test(LegalLastName)) {
          missing += '- Legal representative last name is invalid\r\n';
        }

        // Validate phone number
        var PhoneNumber = document.getElementById('contact[phone]').value;
        if (PhoneNumber.length < 7 && PhoneNumber.length !== 0) {
          missing += '- Phone number needs to have 7 or more numbers\r\n';
        }

        var LegalPhoneNumber =
          document.getElementById('contact[l_phone]').value;
        if (LegalPhoneNumber.length < 7) {
          missing +=
            '- Legal representative phone number needs to have 7 or more numbers\r\n';
        }

        // Adds custom required inputs to the 'required' object
        for (var i = 0; i < customRequired.length; i++) {
          required[customRequired[i].id] = customRequired[
            i
          ].parentNode.firstElementChild.innerHTML.replace('*', '');
        }

        // Iterates through required fields and adds any that have
        // not been populated to 'missing' list

        for (let key in required) {
          var elements = Array.from(
            document.querySelectorAll("[id^='" + key + "']")
          );

          if (elements.length > 0) {
            let missing_field = true;

            elements.forEach(function (el) {
              if (
                el.length < 1 ||
                (el &&
                  ((el.type === 'checkbox' && el.checked) ||
                    (el.type === 'radio' && el.checked) ||
                    (el.type !== 'radio' &&
                      el.type !== 'checkbox' &&
                      el.value) ||
                    (document.getElementById(key + '_other_text') &&
                      document.getElementById(key + '_other_text').value)))
              ) {
                missing_field = false;
              }
            });

            if (missing_field) {
              missing += '- ' + required[key] + '\r\n';
              // console.log('- ' + required[key])
              // missing += ' ';
            }
          }
        }

        // Tests email input value against RFC 5322 Official Standard Email Regex
        var email = document.getElementById('contact[email]').value;
        var legalEmail = document.getElementById('contact[l_email]').value;
        if (
          //eslint-disable-next-line
          !/(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+\])/.test(
            email
          )
        ) {
          missing += '- Purchaser email is invalid\r\n';
          // missing += ' ';
        }

        if (
          //eslint-disable-next-line
          !/(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+\])/.test(
            legalEmail
          )
        ) {
          missing += '- Legal email is invalid\r\n';
          // missing += ' ';
        }

        if (missing !== '') {
          setIsSubmitting(false);
          alert('The following fields are incomplete:\r\n' + missing);
          // alert('Please fill out the required fields.');
          return false;
        }
        // Find the hidden input field and update its value
        const inventoryInput = document.querySelector(
          'input[name="inventory_id"]'
        );
        if (inventoryInput) {
          inventoryInput.value = dataInventory.inventory; // Set inventory ID
        }

        setIsSubmitting(false);

        // alert(document.getElementById('contact[email]').value)
        window.grecaptcha.ready(function () {
          // do request for recaptcha token
          // response is promise with passed token
          // the new recaptcha site-key key for richmond centre
          window.grecaptcha
            .execute('6LdMpVwaAAAAAP059bjmu6TEv7FOdEX6vYZVTGVr', {
              action: 'validate_captcha',
            })
            .then(function (token) {
              // add token value to form
              document.getElementById('g-recaptcha-response').value = token;
              const payload = Object.values(form).reduce((obj, field) => {
                obj[field.name] = field.value;
                return obj;
              }, {});
              //  (LEGAL) ON MAKE
              // test hook: https://hook.us1.make.com/td4np0eivxp99pk97vr89p3yw4fuximt
              // production hook: https://hook.us1.make.com/qqwycgg0sr14sn48bhpfr1smm51ulaop
              form.action =
                'https://hook.us1.make.com/wzhwqs4vtstnwggyf13puotq95v1hi7p';
              form.submit();
            });
        });
        return false;
      }
    } catch (error) {
      console.error('Fetch error:', error);
      alert('An error occurred. Please try again.');
      setIsSubmitting(false);
    }

    setIsSubmitting(false);
  };

  return (
    <Root method="post" accept-charset="UTF-8" ref={$form}>
      <Section>
        <h3>Purchaser Information</h3>
        <FieldsOne>
          <Input
            type={data[0].q.unit.type}
            label={data[0].q.unit.label}
            handleonChange={(e) => setUnitNumber(e.target.value)}
            gridArea="unitNo"
            id={data[0].q.unit.name}
            required={data[0].q.unit.required}
          />
          <Input
            type={data[0].q.strata.type}
            label={data[0].q.strata.label}
            handleonChange={(e) => setStrataLot(e.target.value)}
            gridArea="strataLot"
            id={data[0].q.strata.name}
            required={data[0].q.strata.required}
          />
          <Input
            type={data[0].q.purchaserFirstName.type}
            label={data[0].q.purchaserFirstName.label}
            gridArea="purchaserFirstName"
            id={data[0].q.purchaserFirstName.name}
            required={data[0].q.purchaserFirstName.required}
          />
          <Input
            type={data[0].q.purchaserLastName.type}
            label={data[0].q.purchaserLastName.label}
            gridArea="purchaserLastName"
            restriction="[a-z\d]*"
            id={data[0].q.purchaserLastName.name}
            required={data[0].q.purchaserLastName.required}
          />
          <Input
            type={data[0].q.purchaserEmail.type}
            label={data[0].q.purchaserEmail.label}
            handleonChange={(e) => setPurchaserEmail(e.target.value)}
            gridArea="purchaserEmail"
            id={data[0].q.purchaserEmail.name}
            required={data[0].q.purchaserEmail.required}
          />
          <Input
            type={data[0].q.purchaserPhone.type}
            label={data[0].q.purchaserPhone.label}
            gridArea="purchaserPhone"
            minLength="7"
            maxLength="17"
            id={data[0].q.purchaserPhone.name}
            required={data[0].q.purchaserPhone.required}
          />
        </FieldsOne>
      </Section>
      <Section>
        <h3>Lawyer / Notary Contact Information</h3>
        <FieldsTwo>
          <LawFirmSelector
            dropdownHidden={dropdownHidden}
            setDropdownHidden={setDropdownHidden}
            gridArea="lawFirm"
            lawFirmID={lawFirmID}
            setLawFirmID={setLawFirmID}
            type={data[1].q.lawFirm.type}
            label={data[1].q.lawFirm.label}
            id={data[1].q.lawFirm.name}
          />
          <Input
            type={data[1].q.legalContactFirstName.type}
            label={data[1].q.legalContactFirstName.label}
            gridArea="legalContactFirstName"
            id={data[1].q.legalContactFirstName.name}
            required={data[1].q.legalContactFirstName.required}
          />
          <Input
            type={data[1].q.legalContactLastName.type}
            label={data[1].q.legalContactLastName.label}
            gridArea="legalContactLastName"
            id={data[1].q.legalContactLastName.name}
            required={data[1].q.legalContactLastName.required}
          />
          <Input
            type={data[1].q.legalEmail.type}
            label={data[1].q.legalEmail.label}
            gridArea="legalEmail"
            id={data[1].q.legalEmail.name}
            required={data[1].q.legalEmail.required}
          />
          <Input
            type={data[1].q.legalPhone.type}
            label={data[1].q.legalPhone.label}
            gridArea="legalPhone"
            minLength="7"
            maxLength="17"
            id={data[1].q.legalPhone.name}
            required={data[1].q.legalPhone.required}
          />
        </FieldsTwo>
      </Section>

      <Section>
        <h3>Mortgage Financing Information (If Applicable)</h3>
        <FieldsThree>
          <Input
            type={data[1].q.mortgageInfo.type}
            label={data[1].q.mortgageInfo.label}
            gridArea="mortgageInfo"
            id={data[1].q.mortgageInfo.name}
            required={data[1].q.mortgageInfo.required}
          />
          <input
            type="hidden"
            name="redirect_success"
            id="redirect_success"
            // Production
            // value="https://richmond-centre-forms.netlify.app/rc1-legal-thank-you/"
            //Staging
            value="https://theamazingbrentwood-t5.netlify.app/legal-thank-you/"
          />
          <input
            type="hidden"
            name="redirect_error"
            id="redirect_error"
            // Production
            //value="https://richmond-centre-forms.netlify.app/rc1-legal-representative-form/"
            //Staging
            value="https://theamazingbrentwood-t5.netlify.app/legal-representative-form/"
          />
          <input
            type="hidden"
            id="g-recaptcha-response"
            name="g-recaptcha-response"
          />
          <input type="hidden" name="action" value="validate_captcha" />
          <input type="hidden" name="inventory_id" />
        </FieldsThree>
      </Section>

      <ArrowButton
        text="Submit"
        handleClick={(e) => handleFormSubmit(e)}
        isSubmitting={isSubmitting}
        disabled={isSubmitting}
      />
      <input name="utf8" type="hidden" />
    </Root>
  );
}

const Root = styled.form`
  width: 100%;
  h2 {
    ${vw('margin-bottom', 20, 40)}
    color: ${({ theme }) => theme.color.blue};
  }

  h3 {
    ${vw('margin-bottom', 20, 50)}
  }

  @media ${media.desktop} {
    width: 75%;
  }

  button {
    ${vw('margin-top', 25, 50)}
  }
  label {
    font-family: Big Caslon;
    ${vw('font-size', 16)}
  }
`;

const FieldsOne = styled.div`
  display: grid;
  grid-template-areas:
    'unitNo'
    'strataLot'
    'purchaserFirstName'
    'purchaserLastName'
    'purchaserEmail'
    'purchaserPhone';
  ${vw('grid-column-gap', 0, 24, 20)}
  ${vw('grid-row-gap', 10)}

    @media ${media.tablet} {
    grid-template-areas:
      'unitNo strataLot'
      'purchaserFirstName purchaserLastName'
      'purchaserEmail purchaserPhone';
  }
`;

const FieldsTwo = styled.div`
  display: grid;
  grid-template-areas:
    'lawFirm'
    'legalContactFirstName'
    'legalContactLastName'
    'legalEmail'
    'legalPhone'
    'mortgageInfo';

  ${vw('grid-column-gap', 0, 24, 20)}
  ${vw('grid-row-gap', 10)}

  @media ${media.tablet} {
    grid-template-areas:
      'lawFirm legalEmail'
      'legalContactFirstName legalContactLastName'
      'legalPhone legalPhone'
      'mortgageInfo mortgageInfo';
  }
`;
const FieldsThree = styled.div`
  display: grid;
  grid-template-areas: 'mortgageInfo';

  ${vw('grid-column-gap', 0, 24, 20)}
  ${vw('grid-row-gap', 10)}

  @media ${media.tablet} {
    grid-template-areas: 'mortgageInfo mortgageInfo';
  }
`;

const Section = styled.div`
  ${vw('margin-bottom', 20, 40)}
`;

export default Legal;
